import React from "react";
import BDBreadcrumb from "./BDBreadcrumb";
import "../styles/booking-detail.css";
import BDTitleDetails from "./BDTitleDetails";
import BDUserInfo from "./BDUserInfo";
import BDPaxInfo from "./BDPaxInfo";
import BDTerms from "./BDTerms";
import BDPriceInfo from "./BDPriceInfo";
import BDActions from "./BDActions";
import BDReview from "./BDReview";
import { useGetBookingDetailsQuery } from "../../../rtk-query/slices/bookings/booking-slice";
import BookingDetailShimmer from "./BDShimmer";

function BookingDetailMainWrapper({ id }) {
  const {
    data: bookingDetails,
    isLoading,
    refetch,
  } = useGetBookingDetailsQuery(id);

  return (
    <div className="dod-product-listing-main-wrapper">
      {!isLoading ? (
        <>
          {" "}
          <BDBreadcrumb bookingDetails={bookingDetails?.data} />
          <div className="bd-gray-card-wrapper">
            <BDTitleDetails bookingDetails={bookingDetails?.data} />
            <div className="row">
              <div className="col-lg-7 bd-white-card-wrapper">
                <div className=" d-flex  flex-lg-row flex-column  align-items-start">
                  <BDUserInfo bookingDetails={bookingDetails?.data} />
                  <BDPaxInfo bookingDetails={bookingDetails?.data} />
                </div>
                <div className="d-flex align-items-center flex-md-nowrap border-top pt-3 flex-wrap justify-content-between">
                  <p className="bd-p-pax-info-title flex-shrink-0 p-0 m-0">
                    Total Price:
                  </p>
                  <h1 className="bd-p-header-title p-0 m-0 w-md-max w-100 text-end">
                    AED {bookingDetails?.data?.total_amount}
                  </h1>
                </div>
              </div>
              <div className="col-lg-5 pe-0 ps-lg-2 ps-0">
                <BDTerms bookingDetails={bookingDetails?.data} />
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <BDPriceInfo
                bookingDetails={bookingDetails?.data}
                refetchBookingDetails={refetch}
              />
              <BDActions />
            </div>
          </div>
          {bookingDetails?.data?.customerReview && (
            <div className="bd-gray-card-wrapper mt-3">
              <BDReview bookingDetails={bookingDetails?.data} />
            </div>
          )}
        </>
      ) : (
        <BookingDetailShimmer />
      )}
    </div>
  );
}

export default BookingDetailMainWrapper;
